/* --- BS --- */
import './head_video'

import { currentDevice } from '../../core/utils/currentDevice'
import BottomSheet from '../../shared/bottom_sheet/bottom_sheet'
import Modal from '../../shared/modal/modal'
import { initializeShowHotelsButton, initModal } from '../../shared/offer_modal/offer_modal'
import on from '../../utils/events_delegation'
import { loadHlsVideoByElem } from '../../utils/load_hls_video'
import getRealMarketContent, { dispatchRealMarketContentUpdatedEvent } from '../../utils/real_market_wrapper'
import { FILTER_OFFER_EVENT } from '../hotels_info_with_filtering_packed/hotels_info_with_filtering.constants'

import { initializeUtagEvents } from './header_customized.analytics'

const BLOCK_SELECTOR = '.js-header-customized'
const SHOW_CONDITIONS_BUTTON_SELECTOR = '.js-offer-cta-show-conditions'

function deactivateAllFilterBlocks() {
  document.querySelectorAll('.js-filter').forEach(filterBlock => {
    filterBlock.classList.remove('active')
    filterBlock.querySelector('.js-filter-block').style.display = 'none'

    const filterBlockTitle = filterBlock.querySelector('.js-filter-title')
    filterBlockTitle.classList.remove('active')
    filterBlockTitle.setAttribute('aria-expanded', 'false')
  })
}

function initShowHotelButtonClickLogic() {
  function handlerShowHotelButtonClickLogic(event) {
    if (currentDevice.isMobile) {
      Modal.close()
      BottomSheet.closeAll()
    } else {
      Modal.close()
    }
    const offerId = event.target.dataset.offerId
    const customEvent = new CustomEvent(FILTER_OFFER_EVENT, { detail: { offerId } })
    document.dispatchEvent(customEvent)
  }

  on({
    eventName: 'click',
    selector: '.js-offer-cta-show-hotels',
    handler(e) {
      e.preventDefault()
      handlerShowHotelButtonClickLogic(e)
    },
  })
}

function initializeShowConditionsButton() {
  const showConditionsButton = document.querySelector(SHOW_CONDITIONS_BUTTON_SELECTOR)

  if (!showConditionsButton) return

  let showConditionsBottomSheet

  function handleShowConditionsButtonClick() {
    if (currentDevice.isMobile) {
      // --------------------------------------------------
      // OFFER CONDITIONS BOTTOM SHEET
      // --------------------------------------------------
      if (showConditionsBottomSheet) return

      showConditionsBottomSheet = new BottomSheet({ showButton: showConditionsButton, sheetHeight: 100 })
      const showConditionsBottomSheetElement = showConditionsBottomSheet.getBottomSheetElem()
      const showHotelsButton = showConditionsBottomSheetElement.querySelector('.js-offer-show-hotels')
      showHotelsButton && initializeShowHotelsButton(showHotelsButton)
      showConditionsBottomSheet.show()
    } else {
      const modalId = `js-offer-modal-${showConditionsButton.dataset.offerId}`
      Modal.show(modalId, {
        onShow: modal => {
          ScrollLock.on()
          initModal(`#${modalId}`)

          // move texts from original element to modal
          const setTexts = modal.querySelectorAll('[data-take-text-from]:not([data-text-filled])')

          setTexts.forEach(textElem => {
            const originId = textElem.dataset.takeTextFrom

            if (!originId) return

            const originElem = document.querySelector(`#${originId}`)

            if (!originElem) return

            const clonedElement = originElem.cloneNode(true)

            clonedElement.className = ''

            textElem.appendChild(clonedElement)
            textElem.dataset.textFilled = ''
          })
        },
        onClose: () => {
          ScrollLock.off()
        },
        awaitCloseAnimation: true,
      })
    }
  }

  on({ eventName: 'click', selector: SHOW_CONDITIONS_BUTTON_SELECTOR, handler: handleShowConditionsButtonClick })
}

function initHeaderCustomizedWithOffer() {
  deactivateAllFilterBlocks()
  initShowHotelButtonClickLogic()
  initializeShowConditionsButton()
}

function updateOfferWithRealMarketContent(callback) {
  const blockSelector = '.js-header-with-offer'
  const mainContainer = document.querySelector(blockSelector)
  const blockId = mainContainer?.dataset.blockId
  const constrainedViewId = mainContainer?.dataset.constrainedViewId
  const resourceId = mainContainer?.dataset.resourceId
  const resourceType = mainContainer?.dataset.resourceType
  const additionalParams = `resource_id=${encodeURIComponent(resourceId)}&resource_type=${encodeURIComponent(resourceType)}`
  if (blockId && constrainedViewId) {
    getRealMarketContent({ blockId, constrainedViewId, additionalParams })
      .then(response => {
        const headerContent = document.querySelector('.js-header-with-offer-content')

        if (!headerContent) return

        headerContent.outerHTML = response.html_replacement

        dispatchRealMarketContentUpdatedEvent({ blockSelector, blockName: 'header-with-offer' })
        callback && callback()
      })
      .catch(error => {
        if (error !== 'alreadyApplied') return
        callback && callback()
      })
  } else {
    callback && callback()
  }
}

function initBlock() {
  // Init countdown (deadline requires jquery object)
  $('[data-deadline]')?.deadline()
  if (document.querySelector('.js-header-with-offer-cta')) {
    initHeaderCustomizedWithOffer()
  }
  const headerContainer = document.querySelector(BLOCK_SELECTOR)
  if (headerContainer) {
    loadHlsVideoByElem(headerContainer).catch(error => {
      console.warn('Error loading HLS videos for header_customized block:', error)
    })
  }
  const SEE_LEGAL_CONDITIONS_DATA_SELECTOR = 'data-modal-legal-conditions-trigger'
  if (currentDevice.isMobile) {
    // --------------------------------------------------
    // LEGAL CONDITIONS BOTTOM SHEET
    // --------------------------------------------------
    const seeLegalConditionsCtas = document.querySelectorAll(
      `${BLOCK_SELECTOR} [${SEE_LEGAL_CONDITIONS_DATA_SELECTOR}]`
    )

    if (!seeLegalConditionsCtas.length) return

    seeLegalConditionsCtas.forEach(cta => {
      new BottomSheet({ showButton: cta })
    })
  } else {
    // --------------------------------------------------
    // LEGAL CONDITIONS MODAL
    // --------------------------------------------------
    Modal.init({
      openTrigger: SEE_LEGAL_CONDITIONS_DATA_SELECTOR,
      awaitCloseAnimation: true,
    })
  }

  initializeUtagEvents(BLOCK_SELECTOR)
}

function init() {
  const header = document.querySelector(BLOCK_SELECTOR)

  if (!header) return

  if (document.querySelector('.js-header-with-offer')) {
    updateOfferWithRealMarketContent(initBlock)
  } else {
    initBlock()
  }
}

init()
